"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getFieldValue({ formValue, field, shouldFallbackToDefault, }) {
    return formValue.hasOwnProperty(field.key) || !shouldFallbackToDefault
        ? formValue[field.key]
        : field.default;
}
exports.default = getFieldValue;
